import { Component } from "@angular/core";
import {
  TableRowEmptyStateComponent,
} from "../../../shared/component/table-row-empty-state/table-row-empty-state.component";

@Component({
  selector: 'app-fs-loading-state',
  templateUrl: './fs-loading-state.component.html',
  styleUrls: ['./fs-loading-state.component.scss'],
  imports: [
    TableRowEmptyStateComponent,
  ],
})

export class FsLoadingStateComponent {}
